import { Component, ViewChild } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { IonModal } from '@ionic/angular';
import { AuthRepository } from 'src/app/auth/state/auth.repository';
import { DBS } from 'src/app/classes/database-manager.class';
import { LocalDb } from 'src/app/classes/local-db.class';
import { Week } from 'src/app/interfaces/week.interface';
import { DataService } from 'src/app/services/data.service';
import { UserEvaluationService } from 'src/app/services/firebase/user-evaluation.service';
import { UserTimeService } from 'src/app/services/firebase/user-time.service';
import { WeekCalculatorService } from 'src/app/services/week-calculator.service';
import { AppRepository } from 'src/app/state/app.repository';
@Component({
  templateUrl: './weeks.page.html',
  styleUrls: ['./weeks.page.css']
})
export class WeeksPage {

  weeks: Array<Week> = []
  dbWeeks = new LocalDb(DBS.Weeks)
  dbWorkouts = new LocalDb(DBS.Workouts)
  count: number = 0;
  currentWeek: number = 1;

  constructor(
    private router: Router,
    private dataService: DataService,
    private appRepo: AppRepository,
    private authRepo: AuthRepository,
    private weekCalc: WeekCalculatorService,
    private userTimeService: UserTimeService,
    private userEvaluationService: UserEvaluationService,
    private formBuilder: FormBuilder
  ) {
    const data: Week[] = this.dataService.getData()
    this.createDatabase(data)
    this.downloadUserData()
    this.currentWeek = this.weekCalc.calcWeekNumber(this.authRepo.getState().user.start_at);
  }

  ionViewDidEnter() {
    this.getData()
  }

  async getData() {
    this.weeks = await this.dbWeeks.query({
      field: 'part',
      op: '$eq',
      value: "PRINCIPAL",
      sort_by: 'name'
    })
    this.count = await this.dataService.getFinishedDays()
  }

  async createDatabase(weeks: Week[]) {
    const state = this.appRepo.getState()
    if (state.db_created) {
      return
    }

    weeks.forEach(async week => {
      week.workouts.forEach(async workout => {
        await this.dbWorkouts.save({
          ...workout,
          week_id: week.id,
          when_finalized: [],
        })
      })
      const { workouts, ...weekOnly } = week
      await this.dbWeeks.save(weekOnly)
    })

    state.db_created = true
    this.appRepo.updateState({ ...state })
  }

  async downloadUserData() {
    const state = this.appRepo.getState()
    if (state.downloaded_data) {
      return
    }
    const auth = this.authRepo.getState()

    await this.downloadCompleteExercises(auth.user.id)
    await this.downloadEvaluations(auth.user.id)

    state.downloaded_data = true
    this.appRepo.updateState({ ...state })
  }

  async downloadCompleteExercises(userId: string) {
    const dbFinishedWorkout = new LocalDb(DBS.FinishedWorkouts)
    const times = await this.userTimeService.downloadTimesFromUser(userId)

    for (const time of times) {
      await dbFinishedWorkout.save(time)
    }
  }

  async downloadEvaluations(userId: string) {
    const userEvaluationsDb = new LocalDb(DBS.UserEvaluations)
    const evaluationsFireStore = await this.userEvaluationService.downloadDataFromUser(userId)

    for (const evaluation of evaluationsFireStore) {
      await userEvaluationsDb.save(evaluation)
    }
  }

  async onItemClick(week: Week) {
    if (week.week_number == 1) {
      this.router.navigateByUrl(`days/${week.id}`)
      return
    }

    const evaluatedWeekNumber = week.week_number - 1
    const evaluatedWeek: any = await this.dataService.getWeekByNumber(evaluatedWeekNumber)
    const completed = await this.dataService.weekCompleted(evaluatedWeek.id)
    const alreadyEvaluated = await this.dataService.alreadyEvaluatedWeek(evaluatedWeek.id)

    this.selectedWeek = week
    this.evaluatedWeek = evaluatedWeek

    if (week.week_number > 1 && completed && !alreadyEvaluated) {
      this.modal.present()
    } else {
      this.router.navigateByUrl(`days/${week.id}`)
    }
  }









  @ViewChild(IonModal) modal: IonModal;
  firstQuestion = ''
  secondQuestion = ''
  selectedWeek: Week
  evaluatedWeek: Week


  form = this.formBuilder.group({
    firstQuestion: ['', Validators.required],
    secondQuestion: ['', Validators.required],
  })

  confirm() {
    this.modal.canDismiss = true
    this.modal.dismiss({
      // effortPerception: this.effortPerception
    }, 'confirm');
  }

  onWillDismiss(event: Event) {
    const ev = event as any;
    if (ev.detail.role === 'confirm') {
      this.saveEvaluation()
    }
  }

  firstQuestionChange(event) {
    const value = event.target.value;
    this.form.get('secondQuestion').setValue((value == 'N') ? 'N' : '')
  }

  async saveEvaluation() {
    const userEvaluationsDb = new LocalDb(DBS.UserEvaluations)
    const payload = {
      user_id: this.authRepo.getState().user.id,
      user_email: this.authRepo.getState().user.username,
      week_id: this.evaluatedWeek.id,
      week_number: this.evaluatedWeek.week_number,
      week_level: this.evaluatedWeek.level,
      week_part: this.evaluatedWeek.part,
      week_name: this.evaluatedWeek.name,
      date: new Date(),
      firstQuestion: this.form.value.firstQuestion,
      secondQuestion: this.form.value.secondQuestion
    }
    this.userEvaluationService.create(payload)
    userEvaluationsDb.save(payload)

    this.router.navigateByUrl(`days/${this.selectedWeek.id}`)
  }

}
